import React from "react";
import { useSelector } from "react-redux";

import useDomainCountryCode from "hooks/useDomainCountryCode";
import { getFormattedLocation } from "redux/selectors/location";
import { localizeText } from "utils/localizeText";

import LocationForm from "./LocationForm";

const Hero: React.FC = () => {
  const formattedLocation = useSelector(getFormattedLocation);
  const countryCode = useDomainCountryCode();

  const subHeading = `Shop cannabis ${
    localizeText("dispensaries", countryCode) +
    (formattedLocation ? ` near ${formattedLocation}` : " nearby")
  }.`;

  return (
    <div className="container py-xxl">
      <h1 className="heading--hero mt-sm mb-lg">
        Looking for weed? Start here.
      </h1>
      <p className="mb-xl" data-testid="oo-hero-subheading">
        {subHeading}
      </p>
      <div className="p-none my-md ">
        <LocationForm trackingSource="Hero" />
      </div>
    </div>
  );
};

export default Hero;
